import { render, staticRenderFns } from "./DoctorFemaleIcon.vue?vue&type=template&id=3655c1a0"
import script from "./DoctorFemaleIcon.vue?vue&type=script&lang=js"
export * from "./DoctorFemaleIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports